import get from 'lodash/get';

export const EMAIL_BUNDLE_SIZE = 50;
export const EMAIL_SEND_PRODUCT = 'email_send_product';
export const PREMIUM_FLYER_PRODUCT = 'premium_flyer_design_product';

const getPrice = (product, key) => get(product, key, 0) / 100;

const getPrices = (products, productType) => {
  const product = products.filter(product => product.type === productType)[0];

  const currentPrice = getPrice(product, 'prices.currentPrice');
  const originalPrice = getPrice(product, 'originalPrices.originalPrice');

  return {
    currentPrice,
    originalPrice,
    hasDiscount: currentPrice !== originalPrice,
    discount: Math.round(100 * (1 - currentPrice / originalPrice)),
  };
};

export const getEmailSendPrices = products =>
  getPrices(products, EMAIL_SEND_PRODUCT);
export const getPremiumFlyerPrices = products =>
  getPrices(products, PREMIUM_FLYER_PRODUCT);
